import {Component, OnInit} from '@angular/core';
import {APPCONFIG} from '../../config';
import {Observable} from 'rxjs';
import {UIConfiguration} from '../../cache/uiconfiguration/uiconfiguration';
import {CacheService} from '../../cache/cache.service';

@Component({
  selector: 'my-page-maintenance',
  styles: [],
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss'],
  standalone: false,
})
export class PageMaintenanceComponent implements OnInit {
  public AppConfig: any;
  uiconfiguration: Observable<UIConfiguration>;

  constructor(private cacheService: CacheService) {
    this.uiconfiguration = this.cacheService.getUIConfiguration();
  }

  ngOnInit() {
    this.AppConfig = APPCONFIG;
  }
}
